export default __webpack_public_path__ + "static/logo-main-black-fb4949bb0566e6837680b1dcdaaaf509.png";